import { BRAND } from "constants/brand";
import { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

import { Form } from "react-bootstrap";

import { CSSTransition } from "react-transition-group";
import { Ring } from "@uiball/loaders";
import useHome from "hooks/useHome";
import { readApiError } from "utils/apiError";
import { fieldOf } from "utils/formField";

const EditBanner = (props) => {
    const form = useRef();
    const nodeRef = useRef();
    const { loading, updateAlertsContent } = useHome();

    const submitHandler = async (e) => {
        e.preventDefault();
        const bannerData = new FormData();

        if (fieldOf(form.current, "image").files[0]) {
            bannerData.append(
                "image",
                fieldOf(form.current, "image").files[0],
                fieldOf(form.current, "image").files[0].name,
            );
        }
        bannerData.append("id", props.banner.id);

        bannerData.append("content", fieldOf(form.current, "content").value);
        bannerData.append("discription", fieldOf(form.current, "discription").value);
        bannerData.append("status", fieldOf(form.current, "status").value);

        const result = await updateAlertsContent(bannerData);
        // On a failure the modal stays open with the API's reason (admin#70).
        const failure = readApiError(result, "تعذّر تعديل البانر");
        if (failure) {
            props.showMessage("error", "هناك خطأ", failure);
            return;
        }
        props.showMessage("success", "تم التعديل", "تم تعديل البانر بنجاح");
        props.fetchNumbers();
        props.close();
    };

    return (
        <>
            <div className={`model ${props.show ? "model-show" : ""}`} onClick={props.close}>
                <CSSTransition
                    mountOnEnter
                    unmountOnExit
                    nodeRef={nodeRef}
                    in={props.show}
                    timeout={400}
                    classNames="show"
                >
                    <div className="addItem" ref={nodeRef} onClick={(e) => e.stopPropagation()}>
                        {loading ? (
                            <div className="loading-spinner center">
                                <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                            </div>
                        ) : null}
                        <div className="head center">
                            <h5>تعديل بانر</h5>
                            <FontAwesomeIcon icon={faClose} onClick={props.close} />
                        </div>
                        <Form className="form" ref={form} onSubmit={submitHandler}>
                            <Form.Group className="mb-3" controlId="image">
                                <Form.Label>صوره البانر</Form.Label>
                                <Form.Control
                                    name="image"
                                    type="file"
                                    accept=".png,.jpg,.jpeg,.svg,.webp"
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label>
                                    عنوان البانر<span>*</span>
                                </Form.Label>
                                <Form.Control
                                    name="content"
                                    type="text"
                                    placeholder="عنوان البانر"
                                    defaultValue={props.banner?.content}
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="name2">
                                <Form.Label>
                                    وصف البانر<span>*</span>
                                </Form.Label>
                                <Form.Control
                                    name="discription"
                                    defaultValue={props.banner?.discription}
                                    type="text"
                                    placeholder="وصف البانر"
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="status">
                                <Form.Label>الحاله</Form.Label>
                                <Form.Select name="status" defaultValue={props.banner?.status}>
                                    <option value={"disabled"}>عدم ظهور</option>
                                    <option value={"required"}>ظهور اجباري</option>
                                    <option value={"optional"}>ظهور اختياري</option>
                                </Form.Select>
                            </Form.Group>

                            <div className="buttons">
                                <button className="cancel" onClick={props.close} type="button">
                                    إلغاء
                                </button>
                                <button className="button" type="submit">
                                    حفظ التعديلات
                                </button>
                            </div>
                        </Form>
                    </div>
                </CSSTransition>
            </div>
        </>
    );
};
export default EditBanner;
